import { useAuth } from "../context/AuthContext";
import kloudynetLogo from "@assets/image_1777160759976.png";
import loginBackground from "@assets/image_1777161290849.png";

export function LoginScreen() {
  const { signIn, loading } = useAuth();

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 bg-[#0a1f3a] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${loginBackground})` }}
    >
      <div className="w-full max-w-md bg-[#111827] rounded-2xl shadow-2xl p-8">
        <div className="flex flex-col items-center text-center">
          <img
            src={kloudynetLogo}
            alt="Kloudynet"
            className="h-16 w-auto mb-8"
          />

          <button
            onClick={signIn}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 bg-[#2f2f2f] hover:bg-black text-white py-3 rounded-lg font-medium transition-colors disabled:opacity-60"
          >
            {/* Microsoft 4-square logo, official-ish */}
            <span className="inline-grid grid-cols-2 gap-[2px] w-4 h-4">
              <span className="bg-[#f25022]" />
              <span className="bg-[#7fba00]" />
              <span className="bg-[#00a4ef]" />
              <span className="bg-[#ffb900]" />
            </span>
            <span>Sign in with Microsoft</span>
          </button>

          <p className="mt-6 text-xs text-slate-300 leading-relaxed">
            Use your work or school account. Access is granted by your SOC administrator.
          </p>
          <p className="mt-4 text-[11px] text-slate-500">
            Property of Kloudynet &copy; {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </div>
  );
}
